function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M65.44,157.19c13.79-1.36,28-6.29,41.61-7.26,47.13-3.37,90.71,14.35,114.89,56.06,10.61,18.33,29.6,44,54,40.11,14.54-2.34,28.78-18.41,39.81-28.42,27.84-25.27,51.05-78.51,34.79-115C341.49,82.25,324.92,65.73,305,55.85c-21.14-10.48-47.17-6.78-69.5-14.53C190.65,25.74,143.9-9.73,94,2.53,70.26,8.37,65.79,18,55.18,37.06,49.31,47.61,42.88,59.7,33.1,67.19,16.37,80,.45,86.12,0,111.05s31.11,43.59,52.73,46.14A58.7,58.7,0,0,0,65.44,157.19Z"
}));

function SvgBackgroundW2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355.93 246.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundW2);
export default __webpack_public_path__ + "static/media/background-w-2.a776cf56.svg";
export { ForwardRef as ReactComponent };